// extracted by mini-css-extract-plugin
module.exports = {"items":"Nav-module__items___GDavi","item":"Nav-module__item___1vRwZ","wrapper":"Nav-module__wrapper___g21Km"};